import { GzGeneralCommunicationWebComponent } from './component/GzGeneralCommunicationWebComponent';

export { GzGeneralCommunicationWebComponent };
